<template>
  <div class="columns is-centered">
    <section class="section">
      <div class="box">
        <form enctype="multipart/form-data" class="upload" @submit.prevent="processICS">
          <div class="field">
            <div class="field-body" v-if="uploadUI">
              <div class="field-label">
                <label class="label">Report Name</label>
              </div>
              <div class="field">
                <p class="control">
                  <input required class="input" type="text" id="reportName" v-model="reportName" />
                </p>
              </div>
              <div class="file has-name" :class="{'is-danger':error.iCalendar}">
                <label class="file-label">
                  <input
                    autofocus
                    required
                    class="file-input"
                    type="file"
                    accept="text/calendar"
                    ref="icsFile"
                    id="icsFile"
                    @change="handleFileUpload"
                  />
                  <span class="file-cta">
                    <span class="file-icon">
                      <i class="fas fa-upload"></i>
                    </span>
                    <span class="file-label">Upload iCal File</span>
                  </span>
                </label>
              </div>
            </div>
            <div class="field-body" v-if="syncUI">
              <div class="field-label">
                <label class="label">Report Name</label>
              </div>
              <div class="field">
                <p class="control">
                  <input
                    autofocus
                    required
                    class="input"
                    type="text"
                    id="reportName"
                    v-model="reportName"
                  />
                </p>
              </div>
              <div class="field-label">
                <label class="label">Calendar User</label>
              </div>
              <!-- Display calendar users if the account has them. Optionally display Add Calendar Users if the account has enough subscriptions -->
              <span class="select" v-if="hasCalendarUsers">
                <select v-model="calUser" @change="addCalendarUsers">
                  <option disabled value="disabled">Please select one</option>
                  <option v-if="canAddCalendarUsers">Add Calendar Users</option>
                  <option
                    v-for="calendarUser in calendarUsers"
                    v-bind:value="calendarUser.record_id"
                    :key="calendarUser.calendar_name"
                  >{{calendarUser.calendar_name}}</option>
                </select>
              </span>
              <!-- Only display one option of Add Calendar Users if the account doesn't have any calendar users -->
              <span class="select" v-else>
                <select v-model="calUser" @change="addCalendarUsers">
                  <option disabled value="disabled">Please select one</option>
                  <option>Add Calendar Users</option>
                </select>
              </span>
            </div>
            <AddICSURL />
          </div>

          <div class="field">
            <input
              id="switchRoundedInfo"
              type="checkbox"
              name="switchRoundedInfo"
              class="switch is-rounded is-info"
              checked="checked"
              @click="toggleUI"
            />
            <label for="switchRoundedInfo">{{toggleUIDisplayName}}</label>
          </div>
          <div class="field">
            <input required type="date" />
          </div>
          <div class="field">
            <button
              class="button is-block is-info is-medium is-fullwidth"
              type="submit"
            >Generate Report</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import AddICSURL from "@/components/AddICSURL.vue";
import EventBus from "../event-bus";
import bulmaCalendar from "bulma-calendar/dist/js/bulma-calendar.min.js";
import "bulma-calendar/dist/css/bulma-calendar.min.css";
import "bulma-switch/dist/css/bulma-switch.min.css";
import date from "date-and-time";

export default {
  props: {
    account: Object,
    default: "",
    required: true
  },
  components: {
    AddICSURL
  },
  data() {
    return {
      reportName: "",
      startDate: "",
      endDate: "",
      icsURL: "",
      error: {
        iCalendar: false
      },
      uploadUI: false,
      syncUI: true,
      calendarUsers: [],
      calUser: "disabled",
      reportNameRequired: false
    };
  },
  methods: {
    toggleUI: function() {
      if (this.uploadUI) {
        this.uploadUI = false;
        this.syncUI = true;
      } else {
        this.uploadUI = true;
        this.syncUI = false;
      }
    },
    handleFileUpload: function() {
      this.file = this.$refs.icsFile.files[0];
    },
    processICS: function() {
      this.convertDates();
      if (this.uploadUI) {
        this.uploadCalendar();
      } else {
        this.syncCalendar();
      }
    },
    addCalendarUsers: function() {
      if (this.calUser === "Add Calendar Users") {
        EventBus.$emit("displayAddICSURL", true);
        this.calUser = "disabled";
      }
    },
    getCalendarUsers: function() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/calendaruser")
        .then(httpResponse => {
          if (httpResponse.data.calendar_users) {
            this.calUser = httpResponse.data.calendar_users[0].record_id;
            this.calendarUsers = httpResponse.data.calendar_users;
          }
        })
        .catch(httpError => {
          if (httpError.response.status == 401) {
            localStorage.removeItem("token");
            this.$router.push("/");
          }
        });
    },
    syncCalendar: function() {
      let data = {
        report_name: this.reportName,
        ics_url: this.icsURL,
        calendar_user: this.calUser,
        start_date: this.startDate,
        end_date: this.endDate,
        mileage_reimbursement: process.env.VUE_APP_IRS_MILEAGE_RATE
      };
      this.$http
        .put(process.env.VUE_APP_API_URL + "/calendarsync", data)
        .then(response => {
          this.$nextTick(() => {
            this.$emit("report-id", response.data.report_id);
          });
        })
        .catch(httpError => {
          if (httpError.response) {
            switch (httpError.response.data.error) {
              case "Malformed ICS file":
                this.error.iCalendar = true;
                break;

              case "Invalid MIME type":
                this.error.iCalendar = true;
                break;

              case "Invalid ICS file":
                this.error.iCalendar = true;
                break;

              case "Driver subscriptions exceeded":
                this.error.iCalendar = true;
                break;

              default:
                this.error.iCalendar = true;
            }

            if (httpError.response.status == 500) {
              this.error.iCalendar = true;
            }
          }
        });
    },
    uploadCalendar: function() {
      let formData = new FormData();
      formData.append("ics[]", this.file);
      formData.append("reportName", this.reportName);
      formData.append("startDate", this.startDate);
      formData.append("endDate", this.endDate);
      formData.append(
        "mileageReimbursementRate",
        process.env.VUE_APP_IRS_MILEAGE_RATE
      );

      this.$http
        .post(process.env.VUE_APP_API_URL + "/uploadcal", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          this.$nextTick(() => {
            this.$emit("report-id", response.data.report_id);
          });
        })
        .catch(httpError => {
          if (httpError.response) {
            if (httpError.response.status == 401) {
              localStorage.removeItem("token");
              this.$router.push("/");
            }
            switch (httpError.response.data.error) {
              case "Malformed ICS file":
                this.error.iCalendar = true;
                break;

              case "Invalid ICS file":
                this.error.iCalendar = true;
                break;

              case "Missing ICS UID":
                this.error.iCalendar = true;
                break;

              case "Driver subscriptions exceeded":
                this.error.iCalendar = true;
                break;
            }

            if (httpError.response.status == 500) {
              this.error.iCalendar = true;
            }
          }
        });
    },
    convertDates: function() {
      this.startDate = date.format(this.startDate, "MM/DD/YYYY");
      this.endDate = date.format(this.endDate, "MM/DD/YYYY");
    }
  },
  created: function() {
    this.getCalendarUsers();
  },
  mounted() {
    const calendar = bulmaCalendar.attach(this.$refs.calendarTrigger, {
      startDate: this.date,
      showHeader: true,
      showFooter: true,
      isRange: true,
      labelFrom: "Start Date",
      labelTo: "End Date",
      displayMode: "inline"
    })[0];
    calendar.on(
      "date:selected",
      e => (this.startDate = e.start) && (this.endDate = e.end)
    );
  },
  computed: {
    /*
      Due to the way Vue's component lifecycle works we set this.calendarUsers to an empty object and when the
      component is created this.getCalendarUsers() is called and updates this.CalendarUsers to the correct value
      causing a reactive update which causes this computed property to be re-evaluated. This is required due to
      the nature of Axios async calls.
    */

    canAddCalendarUsers: function() {
      return this.account.subscribedCalendarUsers > this.calendarUsers.length;
    },
    hasCalendarUsers: function() {
      return this.calendarUsers.length > 0;
    },
    toggleUIDisplayName: function() {
      if (this.uploadUI) {
        return "Upload Exported Calendar";
      } else {
        return "Sync Calendar";
      }
    },
    niceDate() {
      if (this.date) {
        return this.date.toLocaleDateString();
      }
    }
  }
};
</script>

<style scoped>
.switch[type="checkbox"] + label::before {
  background: #209cee;
}

.select select {
  text-rendering: auto !important;
}
</style>
